import { render, staticRenderFns } from "./trifle.vue?vue&type=template&id=b088303a&scoped=true&"
import script from "./trifle.vue?vue&type=script&lang=js&"
export * from "./trifle.vue?vue&type=script&lang=js&"
import style0 from "./trifle.vue?vue&type=style&index=0&lang=css&"
import style1 from "./trifle.vue?vue&type=style&index=1&id=b088303a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b088303a",
  null
  
)

export default component.exports